import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

const NewSpinnerTech = lazy(() =>
  import(/* webpackChunkName: "BarretJackson" */ './components/BarrettJackson')
);
const FordMustang = lazy(() =>
  import(
    /* webpackChunkName: "BJFordMustang" */ './components/BarrettJackson/FordMustang'
  )
);
const Porsche = lazy(() =>
  import(
    /* webpackChunkName: "BJPorsche" */ './components/BarrettJackson/Porsche'
  )
);
const Plymouth = lazy(() =>
  import(
    /* webpackChunkName: "BJPlymouth" */ './components/BarrettJackson/Plymouth'
  )
);
const Bugatti = lazy(() =>
  import(
    /* webpackChunkName: "BJBugatti" */ './components/BarrettJackson/Bugatti'
  )
);
const FordGT = lazy(() =>
  import(
    /* webpackChunkName: "BJFordGT" */ './components/BarrettJackson/FordGT'
  )
);

const JimmieJohnson = lazy(() =>
  import(/* webpackChunkName: "JimmieJohnson" */ './components/JimmieJohnson')
);
const JimmieJohnsonVehicleDetails = lazy(() =>
  import(
    /* webpackChunkName: "JJVehicleDetailsPage" */ './components/JimmieJohnson/VehicleDetailsPage'
  )
);
const JimmieJohnsonVoting = lazy(() =>
  import(
    /* webpackChunkName: "JJVotingPage" */ './components/JimmieJohnson/VotingPage'
  )
);
const JimmieJohnsonS2 = lazy(() =>
  import(
    /* webpackChunkName: "JimmieJohnsonS2" */ './components/JimmieJohnsonS2'
  ).then(module => ({ default: module.JimmieJohnson }))
);
const CharityLanding = lazy(() =>
  import(
    /* webpackChunkName: "JimmieJohnsonS2" */ './components/JimmieJohnsonS2'
  ).then(module => ({ default: module.CharityLanding }))
);

export default () => (
  <Suspense fallback={<div />}>
    <Switch>
      <Route exact path="/spinner" component={NewSpinnerTech} />
      <Route exact path="/spinner/2017-ford-gt" component={FordGT} />
      <Route
        exact
        path="/spinner/2018-porsche-911-gt2-rs"
        component={Porsche}
      />
      <Route
        exact
        path="/spinner/1970-plymouth-hemi-cuda"
        component={Plymouth}
      />
      <Route exact path="/spinner/2008-bugatti-veyron" component={Bugatti} />
      <Route
        exact
        path="/spinner/1966-ford-mustang-shelby-gt350"
        component={FordMustang}
      />
      <Route exact path="/driven" component={CharityLanding} />
      <Route exact path="/racing" component={JimmieJohnsonS2} />
      <Route exact path="/racing/post-launch" component={JimmieJohnsonS2} />
      <Route exact path="/s1-racing" component={JimmieJohnson} />
      <Route
        exact
        path="/racing/indy"
        component={JimmieJohnsonVehicleDetails}
      />
      <Route exact path="/racing/indy/vote" component={JimmieJohnsonVoting} />
    </Switch>
  </Suspense>
);
